module.exports = __webpack_public_path__ + "static/media/Group 7903.94d2b394.png";